/**
 * Shared sub-navigation tab strip.
 *
 * Presentational only: it renders the tabs it is handed and marks the active
 * one. Section structure lives in @utils/navigation, not here.
 *
 * A strip of one tab renders nothing — a lone tab is noise, and reserved
 * sections (Runs, Dashboards) start life with a single registered entry.
 */

import type { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

export interface TabNavItem {
  label: string;
  to: string;
}

interface TabNavProps {
  tabs: TabNavItem[];
  ariaLabel: string;
}

export function TabNav({ tabs, ariaLabel }: TabNavProps): ReactElement | null {
  if (tabs.length <= 1) return null;

  return (
    <nav className="tab-nav" aria-label={ariaLabel}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end
          className={({ isActive }) =>
            isActive ? 'tab-nav__tab tab-nav__tab--active' : 'tab-nav__tab'
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
